import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import Chip from '@material-ui/core/Chip';
import Icon from '@material-ui/core/Icon';
import Tooltip from '@material-ui/core/Tooltip';
import classnames from 'classnames';

const propTypes = {
  classes: PropTypes.shape({}).isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  isSelected: PropTypes.bool.isRequired,
  isORv4: PropTypes.bool,
};

const defaultProps = {
  isORv4: false,
};

export function UnstyledRocketChip({ classes, label, onClick, isSelected, isORv4, ...rest }) {
  let icon = <React.Fragment>&nbsp;</React.Fragment>;
  if (isORv4) {
    icon = <Icon>open_in_new</Icon>;
  } else if (isSelected) {
    icon = <Icon>done</Icon>;
  }

  const theChip = (
    <Chip
      variant={isORv4 ? 'outlined' : 'default'}
      label={label}
      onClick={onClick}
      onDelete={onClick}
      deleteIcon={icon}
      className={classnames(
        classes.chip,
        isSelected ? classes.chipSelected : null,
        isORv4 ? classes.orv4Chip : null,
      )}
      classes={{
        root: classes.chipRoot,
        label: isSelected || isORv4 ? null : classes.chipUnselectedLabel,
        icon: classes.chipIcon,
        deleteIcon: classes.chipDeleteIcon,
      }}
      {...rest}
    />
  );

  if (isORv4) {
    return <Tooltip title="Exit to app.objectrocket.com">{theChip}</Tooltip>;
  }
  return theChip;
}

UnstyledRocketChip.propTypes = propTypes;
UnstyledRocketChip.defaultProps = defaultProps;

const styles = (theme) => ({
  chip: {
    justifyContent: 'space-between',
    backgroundColor: theme.customColors.lightGrey,
    marginTop: theme.spacing(1),
    '&:not(:last-child)': {
      marginRight: theme.spacing(1),
    },
    '&:hover': {
      backgroundColor: 'theme.customColors.lightGrey',
    },
    '&:active, &:focus': {
      backgroundColor: theme.customColors.peach,
    },

    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
  orv4Chip: {
    backgroundColor: theme.customColors.white,
    borderColor: theme.customColors.darkGrey,

    '&:active, &:focus': {
      backgroundColor: `${theme.customColors.white} !important`,
    },
  },
  chipSelected: {
    backgroundColor: theme.customColors.peach,
  },
  chipContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '90%',
    marginTop: `-${theme.spacing(1)}px`,

    [theme.breakpoints.down('xs')]: {
      width: '100%',
      flexDirection: 'column',
      marginTop: theme.spacing(0.5),
    },
  },
  chipUnselectedLabel: {
    paddingRight: theme.spacing(5.6),
  },
  chipRoot: {
    marginTop: theme.spacing(1),
    justifyContent: 'space-between',
    '&:not(:last-child)': {
      marginRight: theme.spacing(1),
    },

    [theme.breakpoints.down('xs')]: {
      '&:not(:last-child)': {
        marginRight: 0,
        marginBottom: theme.spacing(1),
      },
      flex: 'unset',
      minWidth: 'unset',
      maxWidth: 'unset',
      marginTop: 0,
    },
  },
  chipIcon: {
    backgroundColor: theme.customColors.teal,
    padding: '2px',
    borderRadius: '50%',
  },
  chipDeleteIcon: {
    color: theme.customColors.teal,
    marginLeft: theme.spacing(1),
  },
});

export default withStyles(styles)(UnstyledRocketChip);
